module.exports = __webpack_public_path__ + "img/icon_macro.db361abc.svg";